function UIDivider({height = '10px'}) {

    return (
        <>
            <div style={{height: height}}/>
        </>
    );
}

export default UIDivider;